import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["isHero"];

  connect() {
    console.log("record-attachments connected...");
  }

  toggleIsHero(event) {
    if (event.currentTarget.checked) {
      this.isHeroTargets.forEach((target) => {
        if (target !== event.currentTarget) {
          target.checked = false;
        }
      });
    } else if (this.hasIsHeroTarget) {
      this.isHeroTarget.checked = true;
    }
  }
}
